import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_detection';
export const useEventDetectionTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    button_face_to_card: 'Лицо в карточку',
    attributes: 'Атрибуты',
    additional_properties: 'Дополнительные свойства',
    no_data: 'Нет данных',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    button_face_to_card: 'Face to card',
    attributes: 'Attributes',
    additional_properties: 'Additional properties',
    no_data: 'No data',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    button_face_to_card: 'Cara a carta',
    attributes: 'Atributos',
    additional_properties: 'Propiedades adicionales',
    no_data: 'Sin datos',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    button_face_to_card: 'Cara para carta',
    attributes: 'Atributos',
    additional_properties: 'Propriedades adicionais',
    no_data: 'Sem dados',
  },
}) : {}) as Record<string, unknown>;
